import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/api/users/user.service';
import { AuthService } from '../services/auth.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-account-not-activated',
  templateUrl: './account-not-activated.component.html'
})
export class AccountNotActivatedComponent implements OnInit {

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private snackbarService: SnackbarService) {

  }

  ngOnInit() {
  }

  public send() {
    const auth0UserId = this.authService.lastAuthentictionError.user_id;
    this.userService.resendVerificationEmail(auth0UserId).subscribe(() => {
      this.snackbarService.openInfo(`Verification email resent!`);
    });
  }
}
